import { useQuery } from '@tanstack/react-query'

import { api } from '../../shared/api'

const FALLBACK = { locales: ['en'], defaultLocale: 'en', siteUrl: null }

/** Site languages (`CONTENT_LOCALES`); `loaded` is false while the fallback is shown. */
export function useLocales() {
  const { data } = useQuery({
    queryKey: ['locales'],
    queryFn: () =>
      api<{
        locales: string[]
        defaultLocale: string
        siteUrl: string | null
      }>('/locales'),
    staleTime: Infinity,
  })

  return { ...(data ?? FALLBACK), loaded: !!data }
}
